<template>
  <div class="hf" :style="getStyle()">
    <ProStep
      v-for="(step, index) in steps"
      :step="step"
      :final="index === steps.length - 1"
      :initial="index === 0"
      :isNext="index < steps.length - 1"
      :isNextActive="isNextActive(index)"
      :isNextCompleted="isNextCompleted(index)"
      :key="'step-f-'+index.toString()"
    />
  </div>
</template>

<script>
import ProStep from "../../0_atoms/stepper/ProStep.vue";

export default {
  name: "ProgressStepper",
  components: {
    ProStep
  },

  data() {
    return {
      top: -35
    };
  },
  props: {
    steps: Array,
    sticky: Number
  },
  mounted() {
    if (this.sticky != null)
      window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    if (this.sticky != null)
      window.removeEventListener("scroll", this.handleScroll);
  },

  methods: {
    handleScroll(e) {
      let pos = window.scrollY - 35;
      pos = pos - this.sticky;
      if (pos < -35) pos = -35;
      this.top = pos;
    },
    getStyle() {
      return `position: relative; top: ${this.getTopPosition()}px;`;
    },
    getTopPosition() {
      return this.top;
    },

    isNextActive(i) {
      if (i < this.steps.length - 1) {
        return this.steps[i + 1].active;
      }
      return false;
    },
    isNextCompleted(i) {
      if (i < this.steps.length - 1) {
        return this.steps[i + 1].completed;
      }
      return false;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
